import React, { useState, useEffect, useRef } from 'react'
import { Label, FormGroup } from 'reactstrap'
import _ from 'lodash'

const MultilingualInput = ({
  label,
  data,
  height,
  onChange
}) => {
  const editorRef = useRef()
  const testEditorRef = useRef()
  const [ editorLoaded, setEditorLoaded ] = useState( false )
  const { CKEditor, CustomEditor } = editorRef.current || {}

  useEffect(() => {
    editorRef.current = {
      CKEditor: require( '@ckeditor/ckeditor5-react' ).CKEditor,
      CustomEditor: require( 'ckeditor5-custom-build/build/ckeditor' ),
    }
    setEditorLoaded( true )
  }, [] )

  return(
    <FormGroup onMouseOut={ () => onChange( null, testEditorRef.current.editor ) } >
      <style>
        {`
          .ck-dropdown__panel {
            max-height: 200px !important;
            overflow-y: auto !important;
          }
          .ck-fontsize-option .ck-button__label {
            font-size: 1rem !important;
          }
        `}
      </style>
      { 
        label && (
          <Label>{ label }</Label>
        )
      }
      {
        editorLoaded && (
          <CKEditor
            ref={ testEditorRef }
            editor={ CustomEditor.ClassicEditor }
            onReady={ editor => {
              editor.editing.view.change(( writer ) => {
                writer.setStyle( 'height', height || '400px', editor.editing.view.document.getRoot() )
              })
            }}
            data={ data }
            config={{
              toolbar: [
                'heading',
                '|',
                'fontSize', 'bold', 'italic',
                '|',
                'link',
                'bulletedList', 'numberedList',
                '|',
                'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                '|',
                'imageUpload', 'blockQuote',
                'insertTable', 'mediaEmbed',
                '|',
                'undo', 'redo'
              ],
              heading: {
                options: [
                  { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                  { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                  { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                  { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                  { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                  { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
                  { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                  { model: 'span', view: 'div', title: 'Span' }
                ]
              },
              link: {
                decorators: {
                  openInNewTab: {
                    mode: 'manual',
                    label: 'Open in a new tab',
                    attributes: {
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    }
                  }
                }
              },
              fontSize: { options: _.filter( Array.from( Array( 121 ).keys() ), item => item >= 8 ) }
            }}
          />
        )
      }
    </FormGroup>
  )
}

export default MultilingualInput
